jQuery(document).ready(function ($) {
    // Grab the FSE header
    const $header = $('.bri-header').first();

    

    function getAdminBarHeight() {
        const $adminBar = $('#wpadminbar');

        if (!$adminBar.length) return 0; // not present

        // Check if it's fixed
        const isFixed = $adminBar.css('position') === 'fixed';

        return isFixed ? $adminBar.outerHeight() : 0;
    }

    function getHeaderHeight() {
        return $header.outerHeight();
    }

    function updateStickyHeader() {
        const scrollTop = $(window).scrollTop();
        const adminBarHeight = getAdminBarHeight();
        const headerHeight = getHeaderHeight();

        // Adjust top for admin bar
        $header.css('top', adminBarHeight + 'px');

        const showOffset = 50; // show after 50px scroll
        const hideOffset = headerHeight + adminBarHeight - 50; // hide a bit before reaching top

        if (scrollTop > showOffset) {
            $header.addClass('sticky');
            $header.css({
                transform: 'translateY(0)',
                opacity: 1
            });
        }
        if (scrollTop < hideOffset) {
            $header.css({
                transform: 'unset',
            });
            $header.removeClass('sticky');
        }
    }

    $(window).on('scroll resize', updateStickyHeader);

    // Trigger once on page load
    updateStickyHeader();
});

